import { APIPerson, Person } from '../IPerson'

export const personTransform = (data: APIPerson): Person => ({
  id: data.id,
  firstName: data.first_name,
  lastName: data.last_name,
  avatar: data.avatar,
  establishmentId: data.establishment_id,
  personUuid: data.uuid,
  isCabin: data.is_cabine,
  agbCode: data.agb_code,
})
